export default "__VITE_ASSET__3UrOXa_q__"